import { Stack, Typography } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import CampaignManagerStats from "./Stats/CampaignManagerStats";
import CampaignManagerTable from "./Table/CampaignManagerTable";
import Toolbar from "./Toolbar/Toolbar";

export default function CampaignPage({
  campaignData,
  paginatedCampaigns,
  filteredCampaigns,
}) {
  return (
    <Stack gap={2}>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <LayersOutlinedIcon
              sx={{
                width: "24px",
                height: "24px",
                fill: "#00000099",
              }}
            />
            <Typography
              variant="h4"
              sx={{
                fontWeight: 400,
                fontSize: "16px",
                color: "#00000099",
                lineHeight: "24px",
              }}
            >
              Campañas
            </Typography>
          </Stack>
        </Stack>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            color: "#00000099",
            lineHeight: "24px",
          }}
        >
          Last update: 24/02/2026 16:26:00
        </Typography>
      </Stack>
      <Toolbar />

      <CampaignManagerStats data={campaignData?.summaryCards} />

      <CampaignManagerTable
        data={paginatedCampaigns}
        rowCount={filteredCampaigns.length}
      />
    </Stack>
  );
}
